<template>
<v-layout class="fill-height">
  <v-container
    id="contentDashboard" fluid
    class="fill-height"
  >
    <v-layout>
      <v-row
        align="start"
        justify="start"
      >
        <v-col cols="12" class="pt-1">
          <header-sidebar></header-sidebar>
          <v-card class="table-content">
            <v-snackbar
              v-model="snackbar"
              :color="color"
              right
              top
              multi-line
              app
            >
              {{snackbarText}}
              <v-btn
                text
                dark
                @click="snackbar = false"
              >
                Fermer
              </v-btn>
            </v-snackbar>
            <v-card-title>
              <span style="font-weight:700;">Dossiers</span> 
              <div class="ml-7 mt-1">
                    <v-btn depressed small style="background: linear-gradient(90deg, rgba(13,74,186,1) 0%, rgba(9,155,223,1) 100%); box-shadow:0 0 20px rgba(0,0,0,0.2); color: white;" :to="{name: 'newFolder'}">Nouveau</v-btn>
              </div>
              <v-spacer></v-spacer>
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Rechercher"
                single-line
                hide-details
              ></v-text-field>
            </v-card-title>
            <v-row>
              <v-col md="2">
                <v-select
                  :items="filterSelectbox"
                  v-model="filter"
                  class="filter-selectbox"
                  label="Type"
                  primary
                ></v-select>
              </v-col>
              <v-col md="2">
                <v-select
                  :items="filterClasseSelectbox"
                  v-model="filterClasse"
                  class="filter-selectbox"
                  label="Classe"
                  primary
                ></v-select>
              </v-col>
            </v-row>
            <v-data-table
              :headers="headers"
              :header-props="{ sortIcon: null }"
              :items="dossiers"
              :search="search"
              class="mainTable"
              :expanded.sync="expanded"
              :single-expand=true
              item-key="numdossier"
              show-expand
              @click:row="goToDirectory"
              sort-by="numdossier"
              sort-desc
              :custom-filter="customDataTableItemsFilter"
            >
            <template v-slot:[`item.type`]="{ item }">
                <span class="text-capitalize">{{ item.type }}</span>
            </template>
            <template v-slot:[`item.classe`]="{ item }">
                <span class="text-capitalize">{{ item.classe }}</span>
            </template>
            <template v-slot:[`item.embarquement`]="{ item }">
                <span style="line-height:25px;" v-html="item.embarquement"></span>
            </template>
            <template v-slot:[`item.debarquement`]="{ item }">
                <span style="line-height:25px;" v-html="item.debarquement"></span>
            </template>
            <template v-slot:[`item.from_date`]="{ item }">
                {{ item.from_date | formatDate}}
            </template>
            <template v-slot:[`item.to_date`]="{ item }">
                {{ item.to_date | formatDate}}
            </template>
            <template v-slot:[`item.actions`]="{ item }">
              <div class="trying">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn :to="{ name: 'singleFolder', params: { id: item.id }}" :ripple="false" small icon
                      v-bind="attrs"
                      v-on="on"
                    >
                        <v-icon
                            small
                        >
                            mdi-eye
                        </v-icon>
                    </v-btn>
                  </template>
                  <span>Ouvrir</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn @click.stop="addAvis(item)" :ripple="false" small icon
                      v-bind="attrs"
                      v-on="on"
                    >
                        <v-icon
                            small
                        >
                            mdi-plus-circle-outline
                        </v-icon>
                    </v-btn>
                  </template>
                  <span>Nouvel Avis</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn @click.stop="editFolder(item.id)" :ripple="false" small icon
                      v-bind="attrs"
                      v-on="on"
                    >
                        <v-icon
                            small
                        >
                            mdi-pencil
                        </v-icon>
                    </v-btn>
                  </template>
                  <span>Editer</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn @click.stop="deleteFolder(item)" :disabled="!permissions.includes('delete_dossier')" :ripple="false" small icon
                      v-bind="attrs"
                      v-on="on"
                    >
                        <v-icon
                            small
                        >
                            mdi-delete
                        </v-icon>
                    </v-btn>
                  </template>
                  <span>Supprimer</span>
                </v-tooltip>
              </div>
            </template>
              <template v-slot:expanded-item="{ headers, item }">
                  <td :colspan="headers.length" class="elevation-0">
                    <v-data-table v-if="item.classe == 'Groupage' || item.classe == 'Complet'" :headers="headersAvis" hide-default-footer :items="item.avis" item-key="num_avis" class="elevation-0 second-table" @click:row="goToAvis">
                      <template v-slot:[`item.date`]="{ item }">
                        {{item.date | formatDate}}
                      </template>
                      <template v-slot:[`item.actions`]="{ item }">
                          <v-icon
                              small
                              class="mr-2"
                              @click="editItem(item)"
                          >
                              mdi-pencil
                          </v-icon>
                          <v-icon
                              small
                              @click="deleteItem(item)"
                          >
                              mdi-delete
                          </v-icon>
                      </template>
                    </v-data-table>
                    <v-data-table v-else :headers="headersAvisAerien" hide-default-footer :items="item.avis" item-key="nbl" class="elevation-0 second-table"  @click:row="goToAvis">
                      <template v-slot:[`item.date`]="{ item }">
                        {{item.date | formatDate}}
                      </template>
                      <template v-slot:[`item.actions`]="{ item }">
                          <v-icon
                              small
                              class="mr-2"
                              @click="editItem(item)"
                          >
                              mdi-pencil
                          </v-icon>
                          <v-icon
                              small
                              @click="deleteItem(item)"
                          >
                              mdi-delete
                          </v-icon>
                      </template>
                    </v-data-table>
                  </td>
              </template>
            </v-data-table>
          </v-card>
        <v-dialog v-model="dialog" v-if="dialog" >
          <newAvis :currentDossier="currentDossier" @hide="dialog = false"></newAvis>
        </v-dialog>
        </v-col>
      </v-row>
    </v-layout>
  </v-container>

</v-layout>
</template>

<script>
import newAvis from './avis/new.component'
import headerSidebar from '../commons/header_sidebar.component'
export default {
  name: 'listingFolder',
  data: () => ({
    drawer: true,
    business: 5,
    tab: null,
    filter: '',
    filterClasse: '',
    snackbar: false,
    snackbarText: '',
    color: "success",
    itemsTabs: [
        'GENERAL', 'CARGO', 'COSTS',
    ],
    textTabs: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
    items: [
        {
          id: 1,
          name: 'Prestations',
          children: [],
        },
        {
          id: 5,
          name: 'Fret',
          children: [],
        },
      ],
    model: 1,
    editedItem: {
        name: '',
        calories: 0,
        fat: 0,
        carbs: 0,
        protein: 0,
      },
      defaultItem: {
        name: '',
        calories: 0,
        fat: 0,
        carbs: 0,
        protein: 0,
      },
    filterSelectbox: [
      {text: 'Tous', value: ''},
      {text: 'Import', value: 'Import'},
      {text: 'Export', value: 'Export'}
    ],
    filterClasseSelectbox: [
      {text: 'Tous', value: ''},
      {text: 'Complet', value: 'Complet'},
      {text: 'Groupage', value: 'Groupage'},
      {text: 'Aérien', value: 'Aérien'}
    ],
    mini: false,
    search: '',
    expanded: [],
    currentDossier: {},
    drawerClass: '',
    info: null,
    row: 'import',
    dialog: false,
    businessCompanies: [
      {
        title: 'Import'
      },
      {
        title: 'Export'
      },
    ],
    dossiers: [],
    todayDate: new Date().getDate()+'/'+(new Date().getMonth()+1)+'/'+new Date().getFullYear(),
    headersAvis: [
      {
        text: 'N°BL',
        sortable: false,
        value: 'bl',
      },
      { text: 'Client', value: 'client.fullname' },
      { text: 'N°Avis', value: 'num_avis' },
      { text: 'Date Création', value: 'date' },
      { text: 'Correspondant', value: 'correspondant.nom' },
      { text: 'Fournisseur', value: 'fournisseur' },
      { text: 'P/C', value: 'pc' },
      { text: 'Terme', value: 'terme' },
      { text: 'Actions', value: 'actions', align:"center", sortable: false },
    ],
    headersAvisAerien: [
      { text: 'Client', value: 'client.fullname' },
      { text: 'N°Avis', value: 'num_avis' },
      { text: 'Date Création', value: 'date' },
      { text: 'Correspondant', value: 'correspondant.nom' },
      { text: 'Fournisseur', value: 'fournisseur' },
      { text: 'P/C', value: 'pc' },
      { text: 'Terme', value: 'terme' },
      { text: 'Actions', value: 'actions', align:"center", sortable: false },
    ],
    
  }),
  components: { newAvis, headerSidebar },
  props: ['permissions'],
  mounted () {
    this.axios
      .get('/dossier/listing')
      .then(response => {
        response.data.forEach((item, index) => {
          if(item.classe == 'Aérien'){
            item.navire = item.num_lta
            item.voyage = item.num_vol
            item.embarquement = item.aeroport_depart+ ' <br/> Le ' + this.$options.filters.formatDate(item.from_date)
            item.debarquement = item.aeroport_arrivee+ ' <br/> Le ' + this.$options.filters.formatDate(item.to_date)
            item.armateur = item.compagnie_aerienne
            item.escale = '-'
          }else{
            item.embarquement = item.port_from + ' <br/> Le ' + this.$options.filters.formatDate(item.from_date)
            item.debarquement = item.port_to + ' <br/> Le ' +  this.$options.filters.formatDate(item.to_date)
          }
          item.avis = []
          this.axios.get('/dossier/'+item.id+'/avis')
          .then(resAvis => {
            item.avis = resAvis.data
          })
          this.dossiers.push(item)
          })
          
        })
  },
  computed : {
    headers() {
        return [
        {
          text: 'N°Dossier',
          value: 'numdossier',
          filtrable: true
        },
        { 
          text: 'Type', 
          value: 'type',
          filtrable: true,
          filter: f => { return ( f + '' ).toLowerCase().includes( this[ 'filter' ].toLowerCase() ) }
        },
        {
          text: 'Classe',
          value: 'classe',
          filtrable: true,
          filter: f => { return ( f + '' ).toLowerCase().includes( this[ 'filterClasse' ].toLowerCase() ) }
        },
        { text: 'Navire/N°LTA', value: 'navire' ,filtrable: true },
        { text: 'Voyage/N°Vol', value: 'voyage' ,filtrable: true },
        //{ text: 'Embarquement', value: 'from_date' },
        //{ text: 'Débarquement', value: 'to_date' },
        { text: 'Escale', value: 'escale' },
        { text: 'Armateur/Comp.', value: 'armateur' },
        { text: 'Embarquement', value: 'embarquement' },
        { text: 'Débarquement', value: 'debarquement' },
        { text: 'Actions', value: 'actions', align:"center", width: "148", sortable: false },
      ]
    }
  },
  methods:{
      customDataTableItemsFilter(value, search, items) {
        /*
        Filter for individual words in search string. Filters
        all object values rather than just the keys included
        in the data table headers.
        */
        const wordArray = search
          .toString()
          .toLowerCase()
          .split(' ')
          .filter(x => x)
        return wordArray.every(word =>
          JSON.stringify(Object.values(items))
            .toString()
            .toLowerCase()
            .includes(word)
        )
      },
      goToDirectory(item){
        this.$router.push({name: 'singleFolder', params: {id: item.id}})
      },
      goToAvis(item){
        this.$router.push({name: 'singleFolder', params: {id: item.dossier_id}, query: {avisid: item.id}})
      },
      editFolder(id){
        this.$router.push({name: 'updateFolder', params: {id: id}})
      },
      addAvis(dossier){
        this.dialog=true;
        this.currentDossier=dossier;
      },
      close () {
          this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
          })
      },
      deleteMarchandises (item) {
          const index = this.marchandises.indexOf(item)
          confirm('Are you sure you want to delete this item?') && this.marchandises.splice(index, 1)
      },
      deleteFolder(item) {
        if(item.avis.length === 0 && item.facture === 0){
          const index = this.dossiers.indexOf(item)
          if(confirm('Are you sure you want to delete this item?')){
            this.axios
              .delete('/dossier/delete/'+item.id)
              .then(res => {
                if(res.data === 'error'){
                  this.color = "error"
                  this.snackbarText = "Un erreur est survenu, essayez plus tard."
                  this.snackbar = true
                }else{
                  this.dossiers.splice(index, 1)
                  this.color = "success"
                  this.snackbarText = "Le dossier a été supprimé avec succès."
                  this.snackbar = true
                }
                
              }).catch(e => {
                this.color = "error"
                this.snackbar = true
                this.snackbarText = "Un erreur est survenu, essayez plus tard."
                console.log(e)
              })

          }
        }else{
          this.color = "error"
          this.snackbar = true
          this.snackbarText = "Impossible de supprimer un dossier contenant des avis/factures."
        }
      },
      closeModal(){
        
      },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  
  .v-data-table >>> .second-table .v-data-table-header > tr {
    &:hover{
      background: linear-gradient(90deg, #099bdf 0%, #76d3ff 100%) !important;
    }
    background: linear-gradient(90deg, #099bdf 0%, #76d3ff 100%) !important;
    th, td {
      color: white !important;
      .v-icon{
        color: white !important;
      }
    }
  }
  .mainTable >>> .v-data-table-header > tr {
    &:hover{
      background: linear-gradient(90deg, #0d4aba 0%, #099bdf 100%) !important;
    }
    background: linear-gradient(90deg, #0d4aba 0%, #099bdf 100%) !important;
    th, td {
      color: white !important;
      .v-icon{
        color: white !important;
      }
    }
  }
  .v-data-table >>> .v-data-table__wrapper{
    padding:5px 25px;
  }
  .v-data-table >>> div > table {
    border-spacing: 0 20px;
    tr td:first-child { border-top-left-radius: 25px; border-bottom-left-radius: 25px; }
    tr th:first-child { border-top-left-radius: 25px; border-bottom-left-radius: 25px; }
    tr td:last-child { border-top-right-radius: 25px; border-bottom-right-radius: 25px; }
    tr th:last-child { border-top-right-radius: 25px; border-bottom-right-radius: 25px; }
    tr > th{
      border:0px solid !important;
    }
    tr > td{
      cursor: pointer;
    }
  }
  .mainTable .v-data-table-header{
      background: #81bcff;
      border:0px solid !important;
      
  }
  .second-table .v-data-table-header{
      background: #ffffce;
      
  }
  .filter-selectbox{
    margin-left: 16px;
    width: 63%;
  }
  h1, h2 {
    font-weight: normal;
  }
  .no-width {
    width: 0px !important;
    min-width: 0px !important;
    padding:25px 0px !important;
  }
  ul {
    list-style-type: none;
    padding: 0;
  }
  li {
    display: inline-block;
    margin: 0 10px;
  }
  a {
    color: #42b983;
  }
  .table-content {
    margin: 0 auto;
    margin-top: 25px;
    width: 96%;
    .v-input__control{
      min-width: 210px;
    }
  }
  .second-sidebar {
    box-shadow: 0 0 35px rgba(0,0,0,0.05);
    min-width:360px;
    padding:25px;
  }
  .add-btn {
    background: #207ddd;
    box-shadow: 5px 10px 20px #207ddd40;
    font-size: 12px;
  }
  .toggle-second-sidebar {
    float: left;
    width: 48px;
    height: 48px;
    top: 89px;
    transform: translateX(-24px);
    font-size:12px;
    background: white;
    border: 1px solid rgba(0,0,0,0.1);
    .toggle-icon {
      margin-left:15px;
    }
  }
  
  .v-list--three-line .v-list-item, .v-list-item--three-line {
    min-height: 35px !important;
  }
  .v-list--rounded.v-list--three-line .v-list-item, .v-list--rounded.v-list--three-line .v-list-item:before, .v-list--rounded.v-list--three-line .v-list-item>.v-ripple__container {
      border-radius: 0px !important;
  }
  .v-list-item {
    text-align: left;
  }
  .v-list-item__title {
    font-size: 15px !important;
  }
  .v-list--nav .v-list-item:not(:last-child):not(:only-child), .v-list--rounded .v-list-item:not(:last-child):not(:only-child){
    margin-bottom: 0px !important;
  }
  .v-list-item__content{
    text-align: left !important;
  }
  .v-data-table.mainTable >>> tr:not(.v-data-table__expanded) {
    box-shadow: 10px 10px 20px rgba(0,0,0,0.1);
    border-radius:25px;
  }
  .v-data-table.mainTable >>> td {
    height: 85px;
    border-bottom: 0px solid !important;
    padding: 0px;
  }
  .second-table {
    background: transparent !important;
  }
  .v-data-table.mainTable >>> table {
    .v-data-table__empty-wrapper {
      background: white !important;
      td{
        background: white !important;
        color: rgba(0,0,0,.87) !important;
        &:hover{
          background: white !important;
          color: rgba(0,0,0,.87) !important;
        }
      }
      &:hover{
        background: white !important;
        color: rgba(0,0,0,.87) !important;
      }
      
    }
    tr:not(.v-data-table__expanded, .v-data-table__expanded__content) {
      background: white;
      transition: all 0.2s ease-in;
      &:hover {
        th, td {
          color: white;
          .v-icon{
            color: white;
          }
        }
        background: linear-gradient(90deg, #0d4aba 0%, #099bdf 100%) !important;
        
        th , th.sortable {
          color: white;
          .v-icon{
            color: rgba(255,255,255,0.8);
          }
        }
      }
      
    }
    .v-data-table__expanded__row, .v-data-table__expanded__row:hover{
      
        box-shadow: 0 10px 20px rgba(0,0,0,0.2);
        border-radius: 25px;
        background: linear-gradient(90deg, #0d4aba 0%, #099bdf 100%) !important;
            td {
              color:white;
              .v-icon{
                color:white;
              }
            }
    }
  }
  .v-data-table.second-table >>> td {
    height: 45px;
    padding-left:15px;
  }
</style>



// WEBPACK FOOTER //
// src/views/dashboard/dossier/listing.vue